import React, { useState, useMemo } from "react";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import { s } from "@/app/utils/s";
import { debounce } from "@/app/utils/custom_function";

interface SearchInputProps {
  onChange?: (value: string) => void;
}

const SearchInput: React.FC<SearchInputProps> = ({ onChange = () => {} }) => {
  const [value, setValue] = useState("");
  const { t } = useTranslation();

  const debouncedOnChange = useMemo(() => debounce(onChange, 500), [onChange]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setValue(newValue);
    debouncedOnChange(newValue);
  };

  return (
    <div className={styles.searchBar}>
      <input
        type="text"
        value={value}
        onChange={handleInputChange}
        className={styles.input}
        placeholder={t(s.search)}
      />
    </div>
  );
};

export default SearchInput;
